import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import { TEXT_COLORS, sameColor } from '../utils/textColors';
/**
 * The text colour button's swatches (TextColorDropdown's menu, its phone
 * modal).
 */
export default class TextColorPalette extends Component {
  view() {
    const {
      current,
      onpick,
      withDefault
    } = this.attrs;
    return m("div", {
      className: "TextColorPalette"
    }, m("div", {
      className: "TextColorPalette-swatches"
    }, TEXT_COLORS.map(_ref => {
      let {
        value,
        name
      } = _ref;
      const label = extractText(app.translator.trans(`champis-forum.forum.text_color.colors.${name}`));
      return m("button", {
        type: "button",
        className: classList('TextColorPalette-swatch', {
          active: sameColor(current, value)
        }),
        style: {
          backgroundColor: value
        },
        title: label,
        "aria-label": label,
        "aria-pressed": sameColor(current, value) ? 'true' : 'false',
        onclick: () => onpick(value)
      });
    })), withDefault && m(Button, {
      className: "Button Button--link TextColorPalette-default",
      icon: "fas fa-times",
      onclick: () => onpick(null)
    }, app.translator.trans('champis-forum.forum.text_color.default_button')));
  }
}
flarum.reg.add('champis-forum', 'forum/components/TextColorPalette', TextColorPalette);